import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";
import PlanDetailsCard from "@/components/settings/PlanDetailsCard";
import { getErrorMessage } from "@/lib/lutely-api/error-manager";

import { useSubscriptionControllerHandleCheckoutSessionCompleted } from "@/lib/lutely-api/gen/subscription/subscription";
import { createFileRoute, useSearch, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { z } from "zod";
import { IoChevronBack } from "react-icons/io5";

const searchSchema = z.object({
  session_id: z.string().optional(),
});

export const Route = createFileRoute("/account/settings/plan")({
  component: RouteComponent,
  validateSearch: searchSchema,
  head: () => ({ meta: [{ title: "Plan | Lutely" }] }),
});

function RouteComponent() {
  const searchParameters = useSearch({ from: "/account/settings/plan" });
  const sessionId = searchParameters.session_id;
  const { data: user, refetch: refetchUser } = useLoggedInUser();

  const checkoutSession =
    useSubscriptionControllerHandleCheckoutSessionCompleted();

  useEffect(() => {
    const handleSession = async () => {
      if (user && sessionId && checkoutSession.isIdle) {
        try {
          await checkoutSession.mutateAsync({ params: { sessionId } });
          toast.success("Your Subscription has been activated", {
            autoClose: 3000,
            toastId: "subscription-success",
          });
          refetchUser();
        } catch (err: any) {
          toast.error(getErrorMessage(err) || "An error occurred", {
            autoClose: 3000,
          });
        }
      }
    };
    handleSession();
  }, [sessionId, checkoutSession, refetchUser, user]);

  return (
    <>
      {/* Mobile Back Button */}
      <div className="md:hidden flex items-center gap-2 mb-6">
        <Link
          to="/account/settings"
          className="flex items-center justify-center w-[34px] h-[34px] bg-white rounded-full shadow-md"
        >
          <IoChevronBack className="text-[20px]" />
        </Link>
        <h1 className="text-[24px] font-semibold">Plan Details and Billing</h1>
      </div>

      {/* Same card Account Information shows; this route also remains the
          Stripe checkout return URL (?session_id=), handled above. */}
      <PlanDetailsCard />
    </>
  );
}
